import { Modal, Form, Input, message, Typography } from 'antd';
import { useState } from 'react';

import { apiClient } from '../../api_actions';
const { Paragraph, Title } = Typography;
const { TextArea } = Input;


const QuestionModal = ({ open, onClose }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    
    apiClient.post('create/questions',{'text':values['inputField']})
    onClose()
    setLoading(false)
  };

  return (
    <Modal
      title="Help Form"
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()} // Trigger form submission
      confirmLoading={loading}
      afterClose={() => form.resetFields()} // Reset on close
    >
      <Title level={4} className="modal-title">
          Your feedback is important to us!
      </Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="inputField"
          label="Your Input"
          rules={[
            { required: true, message: 'Please enter some text' },
            { min: 3, message: 'Must be at least 3 characters' }
          ]}
        >
          <TextArea rows={4} placeholder="Enter text here" />
        </Form.Item>
      </Form>
      <Paragraph type="primary">
        Please enter any questions or feedback about our site that you have, and our team will respond as soon as possible to the email account attached to your user profile!
      </Paragraph>
    </Modal>
  );
};

export default QuestionModal;
